/**
 * Explicit Sign out intent for **company** users — legacy `?fromLogout=true`
 * (`myaccess.js` `logoutClicked`).
 *
 * FR-330 is company-only. SSI Sign out must not set this marker: Cindy's
 * bounce was SSI Login needing two clicks after Sign out because boot
 * signed out the incoming Microsoft session. SSI Login also clears the
 * marker before starting Microsoft so a leftover company Sign out in the
 * same tab cannot block the first click.
 */

export const FROM_LOGOUT_STORAGE_KEY = 'truspace.fromLogout';

/**
 * Record that this tab just signed out. Survives a same-tab refresh
 * (sessionStorage) so boot does not restore a leftover session.
 */
export function markExplicitLogout(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(FROM_LOGOUT_STORAGE_KEY, '1');
}

/**
 * Clear the Sign out marker after a successful new login / MFA / SSO.
 */
export function clearExplicitLogout(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(FROM_LOGOUT_STORAGE_KEY);
}

/**
 * True when this tab signed out and has not signed in again.
 */
export function hasExplicitLogout(): boolean {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(FROM_LOGOUT_STORAGE_KEY) === '1';
}

/**
 * Whether boot may restore a leftover Supabase session or remember-me cookie.
 *
 * @returns false after company Sign out only (FR-330). SSI never sets the marker.
 */
export function shouldRestoreSessionAfterLogout(): boolean {
  return !hasExplicitLogout();
}
